import StarterKit from "./StarterKit";

import BannerScroll from "./components/BannerScroll";
import ButtonsMagnet from "./components/ButtonMagnet";
import Header from "./components/Header";
import Navs from "./components/Navs";
import NavLang from "./components/NavLang";
import PressReleasesFilter from "./components/PressReleasesFilter";
import Share from "./components/Share";
import StockMarket from "./components/StockMarket";

import BlockAnchor from "./blocks/BlockAnchor";
import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockDirectory from "./blocks/BlockDirectory";
import BlockMovie from "./blocks/BlockMovie";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockScrollingText from "./blocks/BlockScrollingText";
import FilterYears from "./components/FilterYears";
import BlockKeynumberTextVideo from "./blocks/BlockKeynumberTextVideo";
import BlockTimeline from "./blocks/BlockTimeline";
import SubNav from "./components/SubNav";
import BlockCharts from "./blocks/BlockCharts";


window.initMap = function(){
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	BannerScroll.init();
	ButtonsMagnet.init();
	FilterYears.init();
	Header.init();
	Navs.init();
	NavLang.init();
	PressReleasesFilter.init();
	StockMarket.init();
	SubNav.init();

	// Blocks
	BlockAnchor.init();
	BlockBanner.init();
	BlockCharts.init();
	BlockCollapse.init();
	BlockDirectory.init();
	BlockKeynumberTextVideo.init();
	BlockMovie.init();
	BlockQuotes.init();
	BlockSlider.init();
	BlockScrollingText.init();
	BlockSliderScrollable.init();
	BlockTimeline.init();

	Share.init();
});
